import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL,  uniqueToken } from "../../api/DataApis";
import {GpsBaseURL, Role} from "../../api/DataApis";
import axios from "axios";
import Select from 'react-select';


function Add() {
  document.title = "Admin | Add";
  let navigate = useNavigate();


  // State variables
  const [Name, setName] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [PhoneCode, setPhoneCode] =  useState("");
  const [Logo, setLogo] =  useState("");
  const [Password, setPassword] =  useState("");
  const [selectSuperAdmin, setselectSuperAdmin] =  useState(false);
  
  const [loadings, setLoadings] = useState(false);
  const [file, setfile] =  useState(null);
  const [fileName, setFileName] = useState('');
     const [selectedCorporate, setSelectedCorporate] = useState("");

     const [filteredData, setFilteredData] = useState([]);
  const handleName = (e) => setName(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
 const  handlePasswordChange = (e) => setPassword(e.target.value);
 const handleSuperAdminChange = (e) => {
 
  setselectSuperAdmin(e.target.checked); // Updates the state to true/false based on checkbox
};
const handlecorporateChange = (selectedOption) => {
  console.log("selectedOption3wrewgfreh", selectedOption);
  if(selectedOption) {
 setSelectedCorporate( selectedOption._id );
  } 
    else {
      setSelectedCorporate(null); // Reset state when cleared
    }
  
}
const handleFileChange = (e) => setfile(e.target.files[0]);

const corporateOptions = filteredData?.map(corporate => ({
  value: corporate._id,
  label: `${corporate.corporate_name} (${corporate?.email})`,
  _id: corporate._id,
}));

const fetchCorporate = async (page) => {
  setLoadings(true);
  
  // Base API URL
  let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
 
  
try {
    const response = await axios.get(apiEndpoint, {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
      },
    });

    console.log("response", response);

    setFilteredData(response.data?.data);
  // Assuming API returns totalCount for pagination
  } catch (error) {
    console.error("Error fetching users:", error);
  } finally {
    setLoadings(false);
  }
};

// Re-fetch users whenever searchTerm changes
    useEffect(() => {
      if (Role === "false") {
        fetchCorporate();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);

console.log("selectSuperAdmin", selectSuperAdmin);
  const handleLogoChange = (e) => setLogo(e.target.files[0]);
  // Function to handle the update request
  const AddUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Adding Admin...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    // Validate corporate selection when role is "false"
    if (!selectedCorporate && Role === "false") {
      Swal.close(); // Close the loader before showing the error message
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select a Corporate before proceeding.",
      });
      return; // Stop further execution
    }
  
    // Create a new FormData object
    let formData = new FormData();
    formData.append("name", Name);
    formData.append("email", Email);
    if (Password) {
      formData.append("password", Password);
    }
    formData.append("is_super_admin", selectSuperAdmin.toString());
    if (selectedCorporate) {
      formData.append("corporate_id", selectedCorporate);
    }
  
    if (file) {
      formData.append("admin_image", file);
    }
  
    try {
      // Make the API request
      let response = await axios.post(
        `${GpsBaseURL}/register`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "User added successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/admin/list`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to add user. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
  
      console.error("Error in AddUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  
  console.log("selectSuperAdmin", selectSuperAdmin);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Admin
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                            Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                   

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Email
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="email"
                                onChange={handleEmailChange}
                                className="form-control"
                                id="email"
                                name="email"
                                value={Email}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Password
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="password"
                                onChange={handlePasswordChange}
                                className="form-control"
                                id="password"
                                name="password"
                                value={Password}
                                autoComplete="new-password"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {Role === "false" && (
                              <>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Super Admin
                            </label>
                           
                            <div className="col-sm-6">
      <input
        type="checkbox"
        onChange={handleSuperAdminChange}  // Enable the onChange handler to update state
        // className="form-control"
        id="superAdmin"
        name="superAdmin"
        checked={selectSuperAdmin} // Bind the checkbox to the state
     />
        {/* <option>Select Option</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
        </select> */}
    </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>


                        {selectSuperAdmin===false && (
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Select Corporate
                            </label>
                            <div className="col-sm-6">
                            <Select
  options={corporateOptions}
  onChange={handlecorporateChange}
  value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate.id) : null}
  placeholder="Select Corporate"
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      height: '38px', 
      width: '100%',
      boxShadow: 'none',
      minWidth: '0',
      flex: 1,
    }),
  }}
/>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                       )}
                       </>
                      )}
                      <div className="form-group">
  <div className="row">
  <label htmlFor="file_id" className="col-sm-2 control-label">
      Select Image
    </label>
    <div className="col-sm-6">
      <input
        type="file"
        onChange={handleFileChange}
        className="form-control"
                                id="file_id"
                                name="user_image"
      />
      {fileName && (
        <p>Selected File: {fileName}</p>
      )}
    </div>
  </div>
</div>

                          <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddUser}
                              value="Add"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
